import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducers } from './store/reducers';
import { UserEffects } from './store/effects/user.effects';
import { UserService } from './user.service';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('userData', reducers), EffectsModule.forFeature([UserEffects])],
  providers: [UserService],
  declarations: []
})
export class UserModule {}
